import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=169591ec&scoped=true"
import script from "./chat.js?vue&type=script&lang=js&external"
export * from "./chat.js?vue&type=script&lang=js&external"
import style0 from "./chat.scss?vue&type=style&index=0&id=169591ec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169591ec",
  null
  
)

export default component.exports